import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Skeleton } from '@/components/ui/skeleton'
import { AdminAccountDetailView } from '@/containers/AdminAccounts/AdminAccountDetail'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { AdminAccountDetail } from '@/types/Account'

export default function AdminAccountDetailPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'admin.accounts',
  })

  const { data: account, isLoading, mutate } = useSWR<AdminAccountDetail>(
    `/api/v2/admin/accounts/${id}`,
    apiFetcher,
  )

  const title = account?.name || t('detail.title')

  useSetPageHeader({
    breadcrumbs: [
      { href: '/admin/accounts', children: t('title') },
      { href: `/admin/accounts/${id}`, children: title },
    ],
  })

  return (
    <>
      <title>{title}</title>

      <div className="mx-auto w-full max-w-[1280px]">
        {isLoading && (
          <div className="space-y-6">
            <Skeleton className="h-8 w-64" />
            <div className="grid gap-8 lg:grid-cols-[320px_1fr]">
              <Skeleton className="h-64 rounded-lg" />
              <Skeleton className="h-64 rounded-lg" />
            </div>
          </div>
        )}

        {account && (
        <AdminAccountDetailView
          account={account}
          onAccountUpdate={(updatedAccount) => {
            mutate(updatedAccount, { revalidate: false })
          }}
        />
      )}
      </div>
    </>
  )
}
